import request from '@/utils/http';
import {
    Message
} from 'element-ui';
// 导出
/**
 * @param {*} params 请求参数
 * @param {*} url 请求路径
 * @param {*} type 请求类型
 * @param {*} name 名称
 */
export const exportType = (params, url, type, name, callback) => {
    const p1 = new Promise((resolve) => {
        resolve(params);
    });
    p1.then(() => {
        request({
            url: url,
            method: type,
            data: {
                ...params
            },
            responseType: 'arraybuffer'
        }).then(res => {
            try {
                // 如果JSON.parse(enc.decode(new Uint8Array(res.data)))不报错，说明后台返回的是json对象，则弹框提示
                // 如果JSON.parse(enc.decode(new Uint8Array(res.data)))报错，说明返回的是文件流，进入catch，下载文件
                const enc = new TextDecoder('utf-8');
                res = JSON.parse(enc.decode(new Uint8Array(res))); // 转化成json对象
                if (res.code !== '0') {
                    Message.error(res.msg);
                }
                if (+res.code === 0) {
                    Message.success(res.data);
                }
            } catch (error) {
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, name);
                } else {
                    const downloadElement = document.createElement('a');
                    const href = window.URL.createObjectURL(blob); // 创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = name; // 下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); // 点击下载
                    document.body.removeChild(downloadElement); // 下载完成移除元素
                    window.URL.revokeObjectURL(href); // 释放掉blob对象
                }
                Message.success('导出成功');
            }
        }).catch(() => {
            Message.error('导出失败');
        }).finally(() => {
            callback && callback();
        });
    });
};

// 获取异常类型
export const getabnormalType = () => {
    return request({
        url: '/api-sn/syslog/exception/getAllExceptionType',
        method: 'get'
    });
};

// 查询数据列表
export const getDataList = (params) => {
    return request({
        url: '/api-sn/syslog/exception/search',
        method: 'post',
        data: params
    });
};

// 处理
export const disposeList = (params) => {
    return request({
        url: `/api-sn/syslog/exceptionRedoing/${params}`,
        method: 'get'
    });
};

// 产品日志
export const getProductionLog = (params) => {
    return request({
        url: '/api-sn/product/productLog/searchPage',
        method: 'post',
        data: params
    });
};

// 操作日志
export const getoperationLog = (params) => {
    return request({
        url: '/api-sn/log/system/management',
        method: 'post',
        data: params
    });
};

// 标识解析日志
export const getanalysisLog = (params) => {
    return request({
        url: '/api-sn/log/identity/analyze',
        method: 'post',
        data: params
    });
};

// 标识注册日志
export const getregisterLog = (params) => {
    return request({
        url: '/api-sn/log/identity/register',
        method: 'post',
        data: params
    });
};

// 登入日志
export const getenterLog = (params) => {
    return request({
        url: '/api-sn/log/auth/loginPaged',
        method: 'post',
        data: params
    });
};

// 权限维护日志
export const getpermissionLog = (params) => {
    return request({
        url: '/api-sn/log/auth/managePaged',
        method: 'post',
        data: params
    });
};

// 接口日志
export const getApiLog = (params) => {
    return request({
        url: '/api-sn/log/lbcs/interface/searchPage',
        method: 'post',
        data: params
    });
};
